import React, { useEffect, useState } from "react";
import RegistrationForm from "../components/RegistrationForm";
import { getIsClosed } from "../services/api";

const RegistrationPage: React.FC = () => {
  const [isClosed, setIsClosed] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      // const today = new Date();
      const res = await fetch("https://uatformsapi.onrender.com/system");
      const data = await res.json();
      const today = new Date(data.date);
      const closingDate = new Date(2025, 10, 21, 23, 0, 0);
      console.log(today);
      console.log(closingDate);

      // const closingDate = new Date();
      // Mes 10 = Noviembre (0 basado)

      if (today >= closingDate) {
        setIsClosed(true);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const closed = await getIsClosed();
      setIsClosed(closed);
    })();
  }, []);

  if (isClosed) {
    return (
      <section className="relative flex items-center justify-center min-h-screen p-6 overflow-hidden">
        {/* Elementos decorativos de fondo */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-red-200/30 rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute bottom-20 right-10 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          ></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-200/20 rounded-full blur-3xl"></div>
        </div>

        {/* Tarjeta principal */}
        <div className="relative bg-white/95 backdrop-blur-xl border-2 border-red-100 shadow-2xl rounded-3xl p-12 max-w-3xl w-full transform transition-all duration-500 hover:scale-[1.02]">
          {/* Icono superior */}
          <div className="mb-8 relative">
            <div className="absolute inset-0 bg-red-100 rounded-full blur-2xl opacity-50 animate-pulse"></div>
            <img
              src="/feria.png"
              alt="Feria Logo"
              className="w-32 h-32 mx-auto relative z-10 drop-shadow-xl"
            />
          </div>

          {/* Badge de estado */}
          <div className="mb-6 flex justify-center">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-2 rounded-full shadow-lg">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
              <span className="font-bold text-sm uppercase tracking-wide">
                Registro Cerrado
              </span>
            </div>
          </div>

          {/* Título principal */}
          <h1 className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-600 via-red-700 to-orange-600 mb-6 leading-tight">
            Registro Finalizado
          </h1>

          {/* Mensaje principal */}
          <div className="space-y-4 mb-8">
            <p className="text-xl text-gray-700 leading-relaxed">
              El periodo de inscripciones para la{" "}
              <span className="font-bold text-red-700">
                Feria de Emprendedores 2025
              </span>{" "}
              ha concluido.
            </p>

            <div className="bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-red-500 rounded-lg p-5 shadow-sm">
              <p className="text-gray-800 flex items-center gap-3">
                <svg
                  className="w-6 h-6 text-red-600 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                <span>
                  Fecha de cierre:{" "}
                  <span className="font-bold text-red-700">
                    20 de noviembre de 2025
                  </span>
                </span>
              </p>
            </div>
          </div>

          {/* Información adicional */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 mb-8 border border-blue-100">
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
              <svg
                className="w-6 h-6 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              ¿Qué sigue?
            </h3>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>
                  Los solicitantes recibirán una notificación por correo
                  electrónico
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>
                  La feria se llevará a cabo según el cronograma establecido
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>Para consultas, contacta al organizador del evento</span>
              </li>
            </ul>
          </div>

          {/* Badge final */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 px-6 py-3 rounded-full shadow-md border border-green-200">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="font-semibold">Gracias por tu interés</span>
            </div>
          </div>

          {/* Decoración inferior */}
          <div className="mt-8 flex justify-center gap-2">
            <div className="w-2 h-2 bg-red-400 rounded-full animate-bounce"></div>
            <div
              className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"
              style={{ animationDelay: "0.1s" }}
            ></div>
            <div
              className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce"
              style={{ animationDelay: "0.2s" }}
            ></div>
          </div>
        </div>
      </section>
      // <section className="flex items-center justify-center min-h-screen  p-6">
      //   <div className="bg-white/90 backdrop-blur-md border border-gray-100 shadow-xl rounded-2xl p-10 max-w-2xl text-center">
      //     <div className="mb-6">
      //       <img
      //         src="/feria.png"
      //         alt="Feria Logo"
      //         className="w-24 h-24 mx-auto opacity-80"
      //       />
      //     </div>

      //     <h1 className="text-4xl font-extrabold text-red-700 mb-4">
      //       Registro cerrado
      //     </h1>

      //     <p className="text-lg text-red-800 leading-relaxed font-medium">
      //       Ya no se aceptan más solicitudes para participar en la
      //       <span className="font-semibold"> Feria de Emprendedores 2025</span>.
      //     </p>

      //     <p className="mt-4 text-gray-700 text-base">
      //       El periodo de registro finalizó el{" "}
      //       <span className="font-semibold">20 de noviembre de 2025</span>.
      //     </p>

      //     <div className="mt-6">
      //       <span className="inline-block bg-red-100 text-red-700 px-5 py-2 rounded-full text-sm font-semibold">
      //         Gracias por tu interés
      //       </span>
      //     </div>
      //   </div>
      // </section>
    );
  }

  return (
    <section className="flex items-start justify-center py-12">
      <div className="w-full md:max-w-[80vw] px-4">
        {/* Modal-like panel */}
        <div className="bg-white/95 rounded-2xl shadow-2xl border border-gray-100 p-8">
          <div className="mb-6 text-center flex flex-col gap-4 items-center">
            <div>
              <img src="/feria.png" alt="" className="w-28 h-28" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-[var(--uat-blue)]">
                Feria de Emprendedores 2025 UAT-UAMVH
              </h2>
              <p className="mt-2 text-[var(--uat-gray)] ">
                Registra tu emprendimiento para participar en la feria.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
            {/* Left: Info */}
            <aside className="space-y-6 md:sticky top-8 border border-gray-300 rounded-lg">
              <div className="bg-white/70 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-[var(--uat-blue)] mb-3">
                  Información del evento
                </h3>

                <dl className="grid grid-cols-1 gap-3 text-sm text-[var(--uat-gray)]">
                  <div>
                    <dt className="font-medium">Ubicación</dt>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d862.6956038872878!2d-97.8138048898271!3d25.673593250388215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x866559d924bbb5b1%3A0x2cbc2a00e6c44f2e!2sCentro%20Valle%20Hermoso!5e1!3m2!1ses-419!2smx!4v1762707999955!5m2!1ses-419!2smx"
                      allowFullScreen={false}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Principal Square"
                      className="w-full h-96"
                    ></iframe>
                    <dd className="text-[1rem]">
                      Plaza Principal. Calle Cosme Santos (Tamaulipas 1992, Zona
                      Centro, 87500 Valle Hermoso, Tamps.)
                    </dd>
                  </div>

                  <div>
                    <dt className="font-medium">Horario</dt>
                    <dd className="text-[1rem]">Jueves 05:00 pm</dd>
                  </div>

                  <div>
                    <dt className="font-medium">Fecha</dt>
                    <dd className="text-[1rem]">27 de noviembre de 2025</dd>
                  </div>

                  <div>
                    <dt className="font-medium">Recomendaciones</dt>
                    <dd className="text-[1rem]">
                      Es necesario que lleves tu stand, mesa y los demás
                      elementos que consideres necesarios para la exposición y/o
                      comercialización de tus productos o servicios.
                    </dd>
                  </div>

                  <div>
                    <dt className="font-medium">Instrucciones</dt>
                    <dd className="text-[1rem]">
                      Completa el formulario de registro. Una vez enviada la
                      información, el administrador la verificará y confirmará
                      tu inscripción a través de correo electrónico.
                    </dd>
                  </div>
                </dl>
              </div>
            </aside>

            {/* Right: Form */}
            <div>
              <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-300 ">
                <h3 className="text-xl font-semibold text-[var(--uat-blue)] mb-4">
                  Formulario de registro
                </h3>
                <RegistrationForm />
              </div>

              <p className="mt-3 text-xs text-[var(--uat-gray)]">
                Todos los campos marcados con un ‘*’ son requeridos.
              </p>
              <p className="mt-3 text-xs text-[var(--uat-gray)]">
                Al enviar aceptas que la información proporcionada será usada
                para la organización del evento y comunicaciones relacionadas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegistrationPage;
